import { Button, Clickable, Col, H1, H2, H3, P, Row, Section, Wrapper } from '@ahmdigital/ui';
import styled from 'styled-components';

import constants from '../../../../ahm-constants';
import Head from '../../../../../utils/head';
import InsuranceSection from '../../../insurance/components/section';
import LegacyBorderedWrapper from '../../../../components/legacy-bordered-wrapper';
import Nav from '../../../../elements/nav';
import SmallDisclaimer from '../small-disclaimer';
import styles from './styles.module.sass';

const handyLinksItems = [
  { name: 'Contact us', url: constants.URLS.SALES.TRAVEL_INSURANCE_CONTACT_US },
  { inNewTab: true, name: 'Manage your policy', url: constants.URLS.THIRD_PARTY.TRAVEL_INSURANCE_SSP },
  { inNewTab: true, name: 'Forms and guides', url: constants.URLS.SALES.TRAVEL_FORMS_AND_GUIDES },
  { name: 'Get a quote', url: constants.URLS.SALES.TRAVEL_INSURANCE },
];

const StyledNav = styled(Nav)`
  border: 1px solid ${({ theme }) => theme.colors.grey20};

  & nav > ul > li {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey10} !important;
    margin-bottom: unset;
    text-underline-offset: 3px;

    &:last-child {
      border-bottom: 0 !important;
    }
  }
`;

const TravelInsuranceMakeClaim = () => (
  <LegacyBorderedWrapper>
    <Head>
      <title>Make a claim - travel insurance</title>
      <meta name="description" content="Make a claim - travel insurance" />
    </Head>
    <Section theme="black" variant="large">
      <Wrapper>
        <H1>Travel insurance</H1>
      </Wrapper>
    </Section>

    <Section variant="large">
      <Wrapper className={styles.content}>
        <InsuranceSection sidebar={<StyledNav items={handyLinksItems} title="Handy links" />}>
          <Row>
            <Col df={9} sm={12}>
              <H2>Make a claim</H2>

              <P looksLike="h4" variant="regular">
                Submit your travel insurance claim online or by post, whatever’s more convenient for you, we’re not
                fussed. We will respond to or settle your travel insurance claim within 10 working days from when we
                receive it.
              </P>

              <H3>Claim online</H3>

              <P>Just enter your claim details and upload a copy of any receipts and supporting documents.</P>

              <Button to={constants.URLS.THIRD_PARTY.TRAVEL_INSURANCE_PARTNERS} variant={styles.button}>
                Make a claim
              </Button>

              <H3>Send your claim by post</H3>

              <ol className={styles.list}>
                <li>
                  <Clickable inNewTab to={constants.URLS.FILES.TRAVEL_INSURANCE_MAKE_A_CLAIM_FORM}>
                    Download a claim form
                  </Clickable>
                </li>
                <li>Print and complete all the sections</li>
                <li>
                  <P>Attach any original supporting documentation required</P>
                  <P>
                    Each section of the form provides details on required documentation such as original receipts (proof
                    of ownership if you are claiming something you had to purchase whilst travelling), police or medical
                    reports. We require original documents so please be sure to make a copy of them before you post your
                    claim.
                  </P>
                </li>
                <li>
                  <P>Post your claim to:</P>
                  <P variant={styles.emphasis}>ahm travel insurance</P>
                  <P variant={styles.emphasis}>c/o Travel Insurance Partners</P>
                  <P variant={styles.emphasis}>PO Box 168</P>
                  <P variant={styles.emphasis}>North Sydney NSW 2060</P>
                </li>
              </ol>

              <P>
                If you have any questions or need help making a claim please{' '}
                <Clickable to={constants.URLS.SALES.TRAVEL_INSURANCE_CONTACT_US}>contact us</Clickable>
              </P>
            </Col>
          </Row>
        </InsuranceSection>
      </Wrapper>
    </Section>
    <InsuranceSection>
      <Wrapper>
        <SmallDisclaimer />
      </Wrapper>
    </InsuranceSection>
  </LegacyBorderedWrapper>
);

export default TravelInsuranceMakeClaim;
